<template>
    <div>
        <slot :manual-link="manualLink"></slot>
    </div>
</template>

<script>
// custom apps/kia 로컬 Faq 의 2025 기아 사업장 평가 매뉴얼(ko/en) 이관 (2026-09-03). ca 는 custom 도 미제공 → ko 폴백
export default {
    name: 'KiaManual',
    computed: {
        manualLink() {
            if (this.$i18n.locale === 'en') {
                return '/document/manual/kia/2025 KIA Online Assessment User Guide_v1_en.pdf';
            }
            return '/document/manual/kia/2025_기아_사업장_평가_시스템_사용_매뉴얼.pdf';
        },
    },
};
</script>
